import { createElement as _createElement } from "react";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { NewsCard } from "@bluframe/mightychroma-mightytool-ui";
import config from "config/site";
import Actions from "./Actions";
import { Row } from "./styled";
const Main = ({ isAdmin, isEditor, newsCards }) => (_jsx(_Fragment, { children: config.news.map((item) => (_jsx(Row, { children: item.rows.map((row) => {
            const newsCard = newsCards[row.serviceName];
            return (_createElement(NewsCard, { ...newsCard, actions: _jsx(Actions, { isAdmin: isAdmin, isEditor: isEditor, serviceName: row.serviceName }), key: row.serviceName, serviceName: row.serviceName }));
        }) }, item.id))) }));
export default Main;
